/* @flow */
import moment from 'moment';

export const getAddress = (state: Object) => {
  return ((state.entities || {}).partnerSessionInfo || {}).destination;
};

export const getPhoneNumber = (state: Object) => {
  return ((state.entities || {}).partnerSessionInfo || {}).phone;
};

export const getFirstName = (state: Object) => {
  return ((state.entities || {}).partnerSessionInfo || {}).first_name;
};

export const getLastName = (state: Object) => {
  return ((state.entities || {}).partnerSessionInfo || {}).last_name;
};

export const getEmail = (state: Object) => {
  return ((state.entities || {}).partnerSessionInfo || {}).email;
};

export const getDate = (state: Object) => {
  const { date } = (state.entities || {}).partnerSessionInfo || {};
  return date ? moment(date) : null;
};

export const getDestinationId = (state: Object) => {
  return (((state.entities || {}).partnerSessionInfo || {}).destination || {}).id;
};



// WEBPACK FOOTER //
// ./src/redux/partners/selectors.js